import {
  CREATE_ATTENDANT_SETTING_REQUESTED,
  CREATE_ATTENDANT_SETTING_SUCCEEDED,
  CREATE_ATTENDANT_SETTING_FAILED,
  GET_ATTENDANT_SETTINGS_REQUESTED,
  GET_ATTENDANT_SETTINGS_SUCCEEDED,
  GET_ATTENDANT_SETTINGS_FAILED,
  UPDATE_ATTENDANT_SETTING_REQUESTED,
  UPDATE_ATTENDANT_SETTING_SUCCEEDED,
  UPDATE_ATTENDANT_SETTING_FAILED,
  REMOVE_ATTENDANT_SETTING_REQUESTED,
  REMOVE_ATTENDANT_SETTING_SUCCEEDED,
  REMOVE_ATTENDANT_SETTING_FAILED,
} from './constants'
import api from '../../utils/api'

export const createAttendantSettingRequested = () => ({
  type: CREATE_ATTENDANT_SETTING_REQUESTED
})

export const createAttendantSettingSucceeded = (payload) => ({
  type: CREATE_ATTENDANT_SETTING_SUCCEEDED,
  payload
})

export const createAttendantSettingFailed = () => ({
  type: CREATE_ATTENDANT_SETTING_FAILED
})

export const getAttendantSettingsRequested = () => ({
  type: GET_ATTENDANT_SETTINGS_REQUESTED
})

export const getAttendantSettingsSucceeded = (payload) => ({
  type: GET_ATTENDANT_SETTINGS_SUCCEEDED,
  payload
})

export const getAttendantSettingsFailed = () => ({
  type: GET_ATTENDANT_SETTINGS_FAILED
})

export const updateAttendantSettingRequested = () => ({
  type: UPDATE_ATTENDANT_SETTING_REQUESTED
})

export const updateAttendantSettingSucceeded = (payload) => ({
  type: UPDATE_ATTENDANT_SETTING_SUCCEEDED,
  payload
})

export const updateAttendantSettingFailed = () => ({
  type: UPDATE_ATTENDANT_SETTING_FAILED
})

export const removeAttendantSettingRequested = () => ({
  type: REMOVE_ATTENDANT_SETTING_REQUESTED
})

export const removeAttendantSettingSucceeded = (payload) => ({
  type: REMOVE_ATTENDANT_SETTING_SUCCEEDED,
  payload
})

export const removeAttendantSettingFailed = () => ({
  type: REMOVE_ATTENDANT_SETTING_FAILED
})

export const createAttendantSetting = (venueUuid, params) => dispatch => {
  dispatch(createAttendantSettingRequested())

  return api
    .createAttendantSetting(venueUuid, params)
    .then(response => dispatch(createAttendantSettingSucceeded(response.data.appDeviceConfigurations)))
    .catch(() => dispatch(createAttendantSettingFailed()))
}

export const loadAttendantSettings = (venueUuid, params) => dispatch => {
  dispatch(getAttendantSettingsRequested())

  return api
    .fetchAttendantSettings(venueUuid, params)
    .then(response => dispatch(getAttendantSettingsSucceeded(response.data.attendantSettings)))
    .catch(() => dispatch(getAttendantSettingsFailed()))
}

export const updateAttendantSetting = (params) => dispatch => {
  dispatch(updateAttendantSettingRequested())

  return api
    .updateAttendantSetting(params)
    .then(response => dispatch(updateAttendantSettingSucceeded(response.data.appDeviceConfigurations)))
    .catch(() => dispatch(updateAttendantSettingFailed()))
}

export const removeAttendantSetting = (uuid) => dispatch => {
  dispatch(removeAttendantSettingRequested())

  return api
    .removeAttendantSetting(uuid)
    .then(response => dispatch(removeAttendantSettingSucceeded(response.data.appDeviceConfiguration)))
    .catch(() => dispatch(removeAttendantSettingFailed()))
}
